import { Route } from "@angular/router";
import { EditStockComponent } from "./edit-stock.component";
import { LigneContratLingePlatResolver } from "./shared/ligne-contrat-linge-plat-resolver";

export const EditStockRouting: Route = {
    path: ":article/edit-stock",
    component: EditStockComponent,
    outlet: "sidebar",
    data: {
        breadcrumb: "Edition de stock"
    },
    resolve:{
        'ligne': LigneContratLingePlatResolver
    }
}
